import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './CatalogosForm.scss';
import imgProcessando from './../../../assets/images/processando_imagem.png';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/catalogos';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faRedoAlt, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import UploadS3 from './../../../components/uploadS3/UploadS3';
import { hasText } from '../../../utils/utils';
const CatalogosForm = props => {

    const history = useHistory();
    const params = useParams();
    const [catalogo, setCatalogo] = useState({});

    const [imagemCapa, setImagemCapa] = useState(null);
    const [imagemLogo, setImagemLogo] = useState(null);
    const [pdfCatalogo, setPdfCatalogo] = useState(null);
    const [catalogos, setCatalogos] = useState([]);

    const { register, handleSubmit } = useForm();

    const onSubmit = data => {
        save(data);
    };

    const carregarCatalogo = useCallback(async (id) => {
        const catalogoInicial = await service.getById(id);
        setCatalogo(catalogoInicial);
        
        if (catalogoInicial.pdf && catalogoInicial.pdf.length > 0) {
            setPdfCatalogo(catalogoInicial.pdf);
        }
        if (catalogoInicial.imagemCapa && catalogoInicial.imagemCapa.length > 0) {
            setImagemCapa(catalogoInicial.imagemCapa);
        }

        if (catalogoInicial.imagemLogo && catalogoInicial.imagemLogo.length > 0) {
            setImagemLogo(catalogoInicial.imagemLogo);
        }
    }, []);

    const getCatalogos = useCallback(async () => {
        const body = params.id ? [{ field: '_id', operator: 'not_equal', value: params.id }] : {};
        const res = await service.getList({ params: body, sort: 'nome' }, 0, 999);
        setCatalogos(res.rows);
    }, [params]);

    useEffect(() => {
        getCatalogos();
        if (params.id) {
            carregarCatalogo(params.id);
        }
    }, [carregarCatalogo, params.id, getCatalogos]);

    const save = async (data) => {
        data["pdf"] = pdfCatalogo;
        data["imagemCapa"] = imagemCapa;
        data["imagemLogo"] = imagemLogo;

        const res = await service.upsert(data, catalogo._id);
        if (!res.erro) {
            history.push("/painel/catalogos");
        } else {
            alert(res.msg);
        }
    }

    const deletePdf = () => {
        setPdfCatalogo(null);
    }
    
    const deleteCapa = () => {
        setImagemCapa(null);
    }

    const deleteLogo = () => {
        setImagemLogo(null);
    }

    const changeCatalogo = e => {
        const _catalogo = { ...catalogo };
        _catalogo.catalogo = e.target.value;
        setCatalogo(_catalogo);
    }

    const optionCatalogos = () => {
        const op = [...catalogos];
        op.unshift({ _id: "", nome: "Selecione um catálogo pai" });
        return op.map((o, i) => {
            return <option key={i} value={o._id}>{o.nome}</option>;
        });
    }

    const setPdf = async (_, params) => {
        setPdfCatalogo(params.Location);
    }

    const setImg = async (_, params) => {
        setImagemCapa(params.Location);
    }

    const setImgLogo = async (_, params) => {
        setImagemLogo(params.Location);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="formModule branco catalogosForm">
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/catalogos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
            <div className="break"></div>
            <div className="field">
                <select name="catalogo" className="hasText" ref={register()} id="catalogo" value={catalogo.catalogo || ""} onChange={(e) => changeCatalogo(e)}>
                    {optionCatalogos()}
                </select>
                <label htmlFor="catalogo">Catálogo pai</label>
            </div>
            <div className="field">
                <input className={catalogo.nome ? 'hasText' : ''} name="nome" id="nome" defaultValue={catalogo.nome} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="nome">Nome</label>
            </div>
            <div className="field">
                <input className={catalogo.apelido ? 'hasText' : ''} name="apelido" id="apelido" defaultValue={catalogo.apelido} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="apelido">Apelido</label>
            </div>
            <div className="field">
                <input className={catalogo.codigo ? 'hasText' : ''} name="codigo" id="codigo" defaultValue={catalogo.codigo} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="codigo">codigo</label>
            </div>
            <div className="break"></div>
            <div className="field">
                <input className={catalogo.descricao ? 'hasText' : ''} name="descricao" id="descricao" defaultValue={catalogo.descricao} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="descricao">Descrição</label>
            </div>
            <div className="field">
                <input className={catalogo.validade ? 'hasText' : ''} name="validade" id="validade" defaultValue={catalogo.validade} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="validade">Validade</label>
            </div>
            <div className="field">
                <input className="hasText" name="ordem" id="ordem" defaultValue={catalogo.ordem} onKeyUp={(e) => hasText(e)} type="number" ref={register({ required: true })} />
                <label htmlFor="ordem">Ordem</label>
            </div>

            <div className="break"></div>
            <div className="subtitulo">Arquivo do catálogo (PDF)</div>
            <div className="break"></div>
            <div className="fieldFile">
                {!pdfCatalogo && <UploadS3 bucket="lekamedia" folder="catalogos" extensions={['pdf']} callback={setPdf} />}
                {pdfCatalogo && <div className="linkPdf"><a href={pdfCatalogo} target="_blank" rel="noopener noreferrer">Clique para ver o pdf</a> <button onClick={(e) => { e.preventDefault(); deletePdf() }}><FontAwesomeIcon icon={faTrashAlt} /></button></div>}
            </div>
            <div className="break"></div>
            <div className="subtitulo">Capa do catálogo</div>
            <div className="break"></div>
            <div className="fieldFile">
                {!imagemCapa && <UploadS3 bucket="lekamedia" folder="catalogos" extensions={['jpg', 'jpeg', 'png']} callback={setImg} />}
                {imagemCapa &&
                    <div className="imagem">
                        <img src={imagemCapa} alt="imagem" />
                        <div className="acoesImagem">
                            <button onClick={(e) => { e.preventDefault(); deleteCapa() }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                        </div>
                    </div>
                }
            </div>
            <div className="break"></div>
            <div className="subtitulo">Logo do catálogo (Etiquetas)</div>
            <div className="break"></div>
            <div className="fieldFile">
                {!imagemLogo && <UploadS3 bucket="lekamedia" folder="catalogos" extensions={['jpg', 'jpeg', 'png']} callback={setImgLogo} />}
                {imagemLogo &&
                    <div className="imagemLogo">
                        <img src={imagemLogo} alt="imagem" />
                        <div className="acoesImagem">
                            <button onClick={(e) => { e.preventDefault(); deleteLogo() }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                        </div>
                    </div>
                }
            </div>
            <div className="break"></div>
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/catalogos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
        </form>
    )
}

export default CatalogosForm;